import React from "react"
import { Box, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import { dsColorNew } from "@palette"

export default function avgSiteHeader() {
	return {
		setHeaderCellProps: () => ({
			sx: { p: 0, borderBottom: 0, minWidth: 90, backgroundColor: dsColorNew.tableHead },
		}),
		render: () => <Box sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexDirection: 'column',
			gap: 0.75,
			backgroundColor: dsColorNew.tableHead,
			pt: 1,
			pb: 0,
		}}>
			<Typography sx={{ fontSize: 12, fontWeight: 600, lineHeight: 1.3 }}>Avg</Typography>
			<Box sx={{ backgroundColor: alpha(dsColorNew.white, 0.08), borderTop: `1px solid ${alpha(dsColorNew.white, 0.12)}`, px: 2, py: 0.25, width: '100%', textAlign: 'center' }}>
				<Typography sx={{ fontSize: 12, fontWeight: 600 }}>⌀</Typography>
			</Box>
		</Box>
	}
}
